/**
 * Types and mappings for interactive event preview functionality.
 * Used to connect preview card elements to their corresponding editor sections/fields.
 */

// Element identifiers for interactive preview
export type PreviewElement =
  | 'colorbar'
  | 'logo'
  | 'title'
  | 'subtitle' // capacity info like "0/30 spots filled"
  | 'perTeam' // per-team limit like "6 per team"
  | 'category' // league name shown in category line
  | 'date'
  | 'time'
  | 'location'
  | 'status'
  | 'description'
  | 'cost'; // entry fee

// Accordion section identifiers
export type EditorSection = 'general' | 'round' | 'signup' | 'advanced';

// Field identifiers within sections
export type FieldTarget =
  | 'name' // EventEssentialsEditor
  | 'logo' // EventEssentialsEditor
  | 'league' // EventEssentialsEditor - LeagueSelector
  | 'maxPlayers' // EventTypeEditor
  | 'calendar' // EventDateCalendar
  | 'course' // EventTimeEditor
  | 'startTime' // EventTimeEditor
  | 'signupDates' // EventSignupTimeEditor
  | 'cost' // EventSignupTimeEditor
  | 'description' // EventAdvancedSettingsEditor
  | 'color' // EventAdvancedSettingsEditor
  | 'teamStructure'; // EventMembershipTypeEditor (Advanced settings)

// Mapping from preview element to section/field
export const ELEMENT_TO_EDITOR: Record<
  PreviewElement,
  { section: EditorSection; field?: FieldTarget }
> = {
  colorbar: { section: 'advanced', field: 'color' },
  logo: { section: 'general', field: 'logo' },
  title: { section: 'general', field: 'name' },
  subtitle: { section: 'general', field: 'maxPlayers' },
  perTeam: { section: 'advanced', field: 'teamStructure' },
  category: { section: 'general', field: 'league' },
  date: { section: 'general', field: 'calendar' },
  time: { section: 'round', field: 'startTime' },
  location: { section: 'round', field: 'course' },
  status: { section: 'signup', field: 'signupDates' },
  cost: { section: 'signup', field: 'cost' },
  description: { section: 'advanced', field: 'description' },
};
